export function scrollToElement($element, duration = 400, offsetHeader = false) {
    if ($element.length === 0) {
        console.warn("Couldn't scroll to element, empty set", $element);
        return;
    }
    let offset = $element.offset().top;

    if (offsetHeader) {
        let headerHeight = $('.header').outerHeight() + 30;
        offset = Math.max(offset - headerHeight, 0);
    }

    $("html,body").stop().animate({scrollTop: offset}, duration);
}
